module.exports = __webpack_public_path__ + "static/media/tapizado-delantero.55258b85.png";